import actionFe from 'utils/mw/actionFe.util';

const feDelPosIntentId = actionFe('feDelPosIntentId');

// noinspection JSUnusedGlobalSymbols
export default feDelPosIntentId;
